import script from "./memberSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./memberSelector.vue?vue&type=script&setup=true&lang=ts"

import "./memberSelector.vue?vue&type=style&index=0&id=35f37be6&lang=less&scoped=true"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f37be6"]])

export default __exports__